import { render } from "./Show.vue?vue&type=template&id=7dd0f14b&scoped=true"
import script from "./Show.vue?vue&type=script&lang=js"
export * from "./Show.vue?vue&type=script&lang=js"

import "./Show.vue?vue&type=style&index=0&id=7dd0f14b&lang=scss&scoped=true"

import exportComponent from "/var/www/onlyfoodies-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd0f14b"]])

export default __exports__